export const PASSWORD_STRENGTHS = [
  {
    progress: 33,
    identifier: 'weak',
  },
  {
    progress: 66,
    identifier: 'good',
  },
  {
    progress: 100,
    identifier: 'strong',
  },
]
